import React  from 'react';
import PropTypes from 'prop-types';

import PuidsProvider from 'core/components/Ad/puids/PuidsProvider';
import BaseTopic from 'core/components/Topic/BaseTopic';
import EmptyWrapper from 'core/components/EmptyWrapper';


/**
 * Компонент отвечает за отображение одной статьи в бесконечном скролле.
 *
 * Он также отвечат за то, какая статья в данный момент активная
 * и передает об этом информацию выше, на основе чего выводятся метатеги
 * и меняется урл
 */
export default class Item extends React.Component {
  static propTypes = {
    /**
     * Данные о текущем топике
     */
    topic: PropTypes.object.isRequired,

    /**
     * Функция вызывается, когда текущий топик становится активным.
     * В нее должна передаваться текущая позиция.
     */
    setActive: PropTypes.func.isRequired,

    /** Номер топика в бесконечном скролле. */
    infinityIndex: PropTypes.number,

    /** Сущность рекомендации из рекомендательного блока */
    recItem: PropTypes.object,

    /** id блока рекомендации */
    rcmBlockId: PropTypes.string,

    /** id первого топика (не из блока рекоммендаций) */
    contextItemId: PropTypes.string,
  };

  // eslint-disable-next-line
  shouldComponentUpdate() {
    /**
     * Этому компоненту нет нужды перерендериваться в рамках бесконечного
     * скролла.
     */
    return false;
  }

  constructor(props, context) {
    super(props, context);
    /**
     * Отправка событий сделалана с помощью ref не случайно.
     * Если это сделать где-то в методе жизненного цикла, то при при CSR
     * там еще не будет дом элементов из-за асинронности PuidsProvider
     */
    this.setShowRef = element => {
      if (element) {
        const {
          recItem,
          infinityIndex,
          rcmBlockId,
          contextItemId,
        } = this.props;

        const topicHeaderElement = element.querySelector('h1');

        if (window.rcm && rcmBlockId && infinityIndex && recItem) {
          this.showObserver = new IntersectionObserver((entries, observer) => {
            if (entries.some(entry => topicHeaderElement ? entry.isIntersecting : entry.intersectionRatio > 0)) {
              window.rcm('fulltextShow', {
                item: recItem,
                blockId: rcmBlockId,
                position: infinityIndex - 1,
                contextItemId,
              });
              observer.disconnect();
            }
          }, {
            threshold: topicHeaderElement ? 1.0 : undefined,
            rootMargin: '0% 0% -50% 0%',
          });
          this.showObserver.observe(topicHeaderElement || element);
        }

        this.setActiveObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.props.setActive();
          }
        }, {
          // Топик становится активным, когда занимает больше половины экрана.
          rootMargin: '-50% 0%',
        });
        this.setActiveObserver.observe(element);
      }
    };
  }

  componentWillUnmount() {
    this.setActiveObserver && this.setActiveObserver.disconnect();
    this.showObserver && this.showObserver.disconnect();
  }

  render() {
    const {
      topic,
      setActive, // eslint-disable-line
      ...otherProps
    } = this.props;

    const infinityIndex = this.props.infinityIndex;
    // Нет смысла перекрывать значения корневого PuidsProvider для первого топика
    const PuidsWrapper = infinityIndex > 0
      ? PuidsProvider
      : EmptyWrapper;

    return (
      <PuidsWrapper link={topic.attributes.link}>
        <div ref={this.setShowRef} id={`article_${infinityIndex}`}>
          <BaseTopic content={topic} {...otherProps} />
        </div>
      </PuidsWrapper>
    );
  }
}
